const windowIsAvailable = typeof window !== 'undefined';

export default windowIsAvailable;
